export const convertBlobToBase64 = (blob, removeHeader = false) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = reject;
  reader.onload = () => {
    let data = reader.result;
    if (removeHeader) {
      const header = ';base64,';
      data = data.substr(data.indexOf(header) + header.length);
    }
    resolve(data);
  };
  reader.readAsDataURL(blob);
});

export const convertBlobToText = blob => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = reject;
  reader.onload = () => {
    const data = reader.result;
    resolve(data);
  };
  reader.readAsText(blob);
});
